module.exports = __webpack_public_path__ + "static/media/404-Page.3b435c84.jpg";